import { Box, Grid, useTheme } from '@mui/material'
import ContentLoader from 'react-content-loader'
interface ISkeleton {
  xs?: number
  sm?: number
  md?: number
  lg?: number
  xl?: number
  cardNo?: number
  height?: string
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ContactDetailsSkeleton = ({ xl, xs, sm, md, lg, cardNo, height }: ISkeleton) => {
  const theme = useTheme()
  return (
    <Box height='100%'>
      <Grid container columnSpacing={{ xs: '1rem' }} rowSpacing={{ xs: '1rem', sm: '0' }}>
        {Array.from(Array(cardNo ? cardNo : 2)).map((_, index) => (
          <Grid
            item
            xs={xs ? xs : 12}
            sm={sm ? sm : 6}
            md={md ? md : 6}
            lg={lg ? lg : 6}
            xl={xl ? xl : 6}
            mt={2}
            key={index}
          >
            <Box
              sx={{
                height: height ? height : '18.75rem',
                paddingRight: '1.45rem',
              }}
            >
              <ContentLoader
                speed={2}
                width={'100%'}
                height={'100%'}
                viewBox='0 0 100% 100%'
                backgroundColor={theme.palette.facilityList.colorTwo}
                foregroundColor={theme.palette.facilityList.colorThree}
              >
                <rect x='8' y='15' rx='0' ry='0' width='260' height='185' />
                <rect x='8' y='210' rx='0' ry='0' width='260' height='18' />
                <rect x='8' y='240' rx='0' ry='0' width='125' height='28' />

                <rect x='140' y='240' rx='0' ry='0' width='125' height='28' />
                <rect x='8' y='275' rx='0' ry='0' width='260' height='13' />
              </ContentLoader>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
export default ContactDetailsSkeleton
